import { service } from "./service";

export function dashboardHomeApi() {
  return service.get(`v3/dashboard/overview`);
}

export function getBookingsApi(payload) {
  return service.get(`v3/dashboard/bookings`, { params: payload });
}

export function getReviewsApi(payload) {
  return service.get(`v3/dashboard/reviews`, { params: payload });
}

export function writeReviewApi(payload, bookingId) {
  return service.post(`v3/dashboard/bookings/${bookingId}/review`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function editReviewApi(payload, bookingId) {
  return service.put(`v3/dashboard/bookings/${bookingId}/review`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function deleteReviewApi(bookingId) {
  return service.delete(`v3/dashboard/bookings/${bookingId}/review`);
}

export function userPaymentsApi(payload) {
  return service.get(`v3/dashboard/payments`, { params: payload });
}

export function getWishListApi(payload) {
  return service.get(`v3/dashboard/favourites`, {
    params: payload,
  });
}

export function getNotificationsApi(payload) {
  return service.get(`v3/dashboard/notifications`, {
    params: payload,
  });
}

export function chatsApi(payload) {
  return service.get(`v3/dashboard/messages/chats`, {
    params: payload,
  });
}

export function singleChatApi({
  bookingId,
  includeBookingDetails = false,
  cursorId = null,
  pageSize = 10,
}) {
  return service.get(`v3/dashboard/messages/chat/${bookingId}`, {
    params: { cursorId, pageSize, includeBookingDetails },
  });
}

export function sendMessageApi({ message, bookingId }) {
  return service.post(`v3/dashboard/messages/chat/${bookingId}`, { message });
}

export function updateAllMessageStatusApi({ bookingId }) {
  return service.patch(
    `v3/dashboard/messages/chat/${bookingId}/mark-as-read/all`
  );
}

export function updateSpecificMessageStatusApi({ bookingId, messageIds }) {
  return service.patch(
    `v3/dashboard/messages/chat/${bookingId}/mark-as-read/specific`,
    { messageIds }
  );
}

export async function getSingleReservationApi(bookingId) {
  return service.get(`v3/dashboard/bookings/${bookingId}`);
}

export async function getCancelBookingDetailsApi({ bookingId }) {
  return service.get(`v3/dashboard/bookings/${bookingId}/cancel`);
}

export async function cancelBookingApi({ bookingId, ...rest }) {
  return service.patch(`v3/dashboard/bookings/${bookingId}/cancel`, rest);
}

export async function emailBookingProperty({ message, bookingId }) {
  return service.post(`v3/dashboard/bookings/${bookingId}/email`, {
    message,
  });
}

export async function editBookingSpecialRequestApi({
  specialRequest,
  bookingId,
}) {
  return service.put(`v3/dashboard/bookings/${bookingId}/special-request`, {
    specialRequest,
  });
}

export async function updateNotificationStatusApi({ notificationIds }) {
  return service.patch(`v3/dashboard/notifications/mark-as-read`, {
    notificationIds,
  });
}
